// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root .G2boy .hvomI{font-size:1.4rem}:root .G2boy .KK9wt{font-size:1.2rem;margin-bottom:1.5rem}:root .G2boy .anoBq,:root .G2boy .aXfrD{font-size:1.1rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationModal": `G2boy`,
	"title": `hvomI`,
	"textHeader": `KK9wt`,
	"extraContent": `anoBq`,
	"text": `aXfrD`
};
module.exports = ___CSS_LOADER_EXPORT___;
